/**
 * @generated SignedSource<<9776aa4d6b83e385189d23bfecf5e33d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueFieldDataType = "DATE" | "MULTI_SELECT" | "NUMBER" | "SINGLE_SELECT" | "TEXT" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type RepositoryVisibility = "INTERNAL" | "PRIVATE" | "PUBLIC" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueCreatePage$data = {
  readonly databaseId: number | null | undefined;
  readonly hasAnyTemplates: boolean;
  readonly hasIssuesEnabled: boolean;
  readonly id: string;
  readonly isArchived: boolean;
  readonly isBlankIssuesEnabled: boolean;
  readonly isInOrganization: boolean;
  readonly isLocked: boolean;
  readonly isOwnerEnterpriseManaged: boolean | null | undefined;
  readonly isPrivate: boolean;
  readonly issueForm?: {
    readonly __typename: "IssueForm";
    readonly assignees: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename?: "User";
          readonly avatarUrl?: string;
          readonly id?: string;
          readonly login?: string;
          readonly name?: string | null | undefined;
          readonly profileResourcePath?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly elements: ReadonlyArray<{
      readonly __typename: "IssueFormElementCheckboxes";
      readonly checkboxOptions: ReadonlyArray<{
        readonly label: string;
        readonly labelHTML: string;
        readonly required: boolean | null | undefined;
      }>;
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
    } | {
      readonly __typename: "IssueFormElementDropdown";
      readonly defaultOptionIndex: number | null | undefined;
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
      readonly multiple: boolean | null | undefined;
      readonly options: ReadonlyArray<string>;
      readonly required: boolean | null | undefined;
    } | {
      readonly __typename: "IssueFormElementInput";
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
      readonly placeholder: string | null | undefined;
      readonly required: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | {
      readonly __typename: "IssueFormElementMarkdown";
      readonly contentHTML: string;
    } | {
      readonly __typename: "IssueFormElementTextarea";
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
      readonly placeholder: string | null | undefined;
      readonly render: string | null | undefined;
      readonly required: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | {
      readonly __typename: "IssueFormElementUpload";
      readonly accept: string | null | undefined;
      readonly descriptionHTML: string | null | undefined;
      readonly itemId: string | null | undefined;
      readonly label: string;
      readonly required: boolean | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    }>;
    readonly filename: string;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly color: string;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly nameHTML: string;
          readonly url: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly projects: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: "ProjectV2";
          readonly closed: boolean;
          readonly hasReachedItemsLimit: boolean;
          readonly id: string;
          readonly number: number;
          readonly title: string;
          readonly url: string;
          readonly viewerCanUpdate: boolean;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly title: string | null | undefined;
    readonly type: {
      readonly color: IssueTypeColor;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly isEnabled: boolean;
      readonly name: string;
      readonly pinnedFields: ReadonlyArray<{
        readonly __typename: "IssueFieldDate";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldMultiSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldNumber";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldSingleSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldText";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly issueTemplate?: {
    readonly __typename: "IssueTemplate";
    readonly assignees: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename?: "User";
          readonly avatarUrl?: string;
          readonly id?: string;
          readonly login?: string;
          readonly name?: string | null | undefined;
          readonly profileResourcePath?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly body: string | null | undefined;
    readonly filename: string;
    readonly labels: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly color: string;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly name: string;
          readonly nameHTML: string;
          readonly url: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly name: string;
    readonly title: string | null | undefined;
    readonly type: {
      readonly color: IssueTypeColor;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly isEnabled: boolean;
      readonly name: string;
      readonly pinnedFields: ReadonlyArray<{
        readonly __typename: "IssueFieldDate";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldMultiSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldNumber";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldSingleSelect";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        readonly __typename: "IssueFieldText";
        readonly dataType: IssueFieldDataType;
        readonly id: string;
        readonly name: string;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      }> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly nameWithOwner: string;
  readonly owner: {
    readonly avatarUrl: string;
    readonly databaseId: number | null | undefined;
    readonly issueTypesEnabled: boolean;
    readonly login: string;
  };
  readonly shortDescriptionHTML: string;
  readonly slashCommandsEnabled: boolean;
  readonly viewerCanCreateIssues: boolean;
  readonly viewerCanPush: boolean;
  readonly viewerInteractionLimitReasonHTML: string | null | undefined;
  readonly viewerIssueCreationPermissions: {
    readonly assignable: boolean;
    readonly canSetIssueFields: boolean;
    readonly labelable: boolean;
    readonly milestoneable: boolean;
    readonly triageable: boolean;
    readonly typeable: boolean;
  };
  readonly visibility: RepositoryVisibility;
  readonly " $fragmentType": "IssueCreatePage";
};
export type IssueCreatePage$key = {
  readonly " $data"?: IssueCreatePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueCreatePage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v5 = [
  {
    "kind": "Variable",
    "name": "filename",
    "variableName": "templateFilter"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "kind": "Literal",
  "name": "first",
  "value": 20
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": [
    (v9/*: any*/),
    {
      "kind": "Literal",
      "name": "orderBy",
      "value": {
        "direction": "ASC",
        "field": "NAME"
      }
    }
  ],
  "concreteType": "LabelConnection",
  "kind": "LinkedField",
  "name": "labels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LabelEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Label",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v10/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nameHTML",
              "storageKey": null
            },
            (v11/*: any*/),
            (v12/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "labels(first:20,orderBy:{\"direction\":\"ASC\",\"field\":\"NAME\"})"
},
v14 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 10
    }
  ],
  "concreteType": "UserConnection",
  "kind": "LinkedField",
  "name": "assignees",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v6/*: any*/),
                (v0/*: any*/),
                (v3/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profileResourcePath",
                  "storageKey": null
                },
                (v4/*: any*/)
              ],
              "type": "Actor",
              "abstractKey": "__isActor"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "assignees(first:10)"
},
v15 = [
  (v0/*: any*/),
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataType",
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "type",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEnabled",
      "storageKey": null
    },
    (v11/*: any*/),
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "pinnedFields",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": (v15/*: any*/),
          "type": "IssueFieldText",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v15/*: any*/),
          "type": "IssueFieldSingleSelect",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v15/*: any*/),
          "type": "IssueFieldDate",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v15/*: any*/),
          "type": "IssueFieldNumber",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v15/*: any*/),
          "type": "IssueFieldMultiSelect",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": "itemId",
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionHTML",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "placeholder",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "required",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "templateFilter"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "withTemplate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueCreatePage",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameWithOwner",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "issueTypesEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOwnerEnterpriseManaged",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visibility",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isArchived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isInOrganization",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasIssuesEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAnyTemplates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slashCommandsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanPush",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isBlankIssuesEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanCreateIssues",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "action",
          "value": "create an issue"
        }
      ],
      "kind": "ScalarField",
      "name": "viewerInteractionLimitReasonHTML",
      "storageKey": "viewerInteractionLimitReasonHTML(action:\"create an issue\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueCreationPermissions",
      "kind": "LinkedField",
      "name": "viewerIssueCreationPermissions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "labelable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "milestoneable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "assignable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "triageable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "typeable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canSetIssueFields",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescriptionHTML",
      "storageKey": null
    },
    {
      "condition": "withTemplate",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "IssueTemplate",
          "kind": "LinkedField",
          "name": "issueTemplate",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v2/*: any*/),
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "body",
              "storageKey": null
            },
            (v8/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v16/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v5/*: any*/),
          "concreteType": "IssueForm",
          "kind": "LinkedField",
          "name": "issueForm",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            (v2/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "elements",
              "plural": true,
              "selections": [
                (v6/*: any*/),
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/),
                    (v20/*: any*/),
                    (v21/*: any*/),
                    (v22/*: any*/)
                  ],
                  "type": "IssueFormElementInput",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/),
                    (v20/*: any*/),
                    (v21/*: any*/),
                    (v22/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "render",
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFormElementTextarea",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "contentHTML",
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFormElementMarkdown",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "options",
                      "storageKey": null
                    },
                    (v22/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "multiple",
                      "storageKey": null
                    },
                    {
                      "alias": "defaultOptionIndex",
                      "args": null,
                      "kind": "ScalarField",
                      "name": "default",
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFormElementDropdown",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/),
                    {
                      "alias": "checkboxOptions",
                      "args": null,
                      "concreteType": "IssueFormElementCheckboxOption",
                      "kind": "LinkedField",
                      "name": "options",
                      "plural": true,
                      "selections": [
                        (v18/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "labelHTML",
                          "storageKey": null
                        },
                        (v22/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFormElementCheckboxes",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v17/*: any*/),
                    (v18/*: any*/),
                    (v19/*: any*/),
                    (v22/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "accept",
                      "storageKey": null
                    }
                  ],
                  "type": "IssueFormElementUpload",
                  "abstractKey": null
                }
              ],
              "storageKey": null
            },
            (v13/*: any*/),
            (v14/*: any*/),
            {
              "alias": null,
              "args": [
                (v9/*: any*/)
              ],
              "concreteType": "ProjectV2Connection",
              "kind": "LinkedField",
              "name": "projects",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectV2Edge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectV2",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        (v0/*: any*/),
                        (v8/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "closed",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "number",
                          "storageKey": null
                        },
                        (v12/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "viewerCanUpdate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasReachedItemsLimit",
                          "storageKey": null
                        },
                        (v6/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "projects(first:20)"
            },
            (v16/*: any*/)
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Repository",
  "abstractKey": null
};
})();

(node as any).hash = "f19e7c18b354002bde71e311a8345468";

export default node;
